import { render, staticRenderFns } from "./ICDAdendaUpload.vue?vue&type=template&id=6ef6583b&scoped=true&"
import script from "./ICDAdendaUpload.vue?vue&type=script&lang=js&"
export * from "./ICDAdendaUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef6583b",
  null
  
)

export default component.exports